import { render } from "./PerformanceRatesChart.vue?vue&type=template&id=87d5f8d2&scoped=true"
import script from "./PerformanceRatesChart.vue?vue&type=script&lang=js"
export * from "./PerformanceRatesChart.vue?vue&type=script&lang=js"

import "./PerformanceRatesChart.vue?vue&type=style&index=0&id=87d5f8d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d5f8d2"]])

export default __exports__